import React from 'react'
import { lightTheme } from '@/customTheme'

interface AddPhotoIconProps {
  size?: number
  fill?: string
}

function AddPhotoIcon({ size = 24, fill = lightTheme.colors.blackGray }: AddPhotoIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        fill={fill}
        d="M12 2V4H5C4.44771 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V12H22V19C22 20.6051 20.7394 21.9158 19.1543 21.9961L19 22H5L4.8457 21.9961C3.31166 21.9184 2.08163 20.6883 2.00391 19.1543L2 19V5C2 3.34315 3.34315 2 5 2H12Z"
      />
      <path
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z"
      />
      <path
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.97329 11C8.23944 11 8.4946 11.1061 8.68229 11.2948L13.9412 16.5821L16.2162 14.2949C16.6039 13.9052 17.2334 13.9014 17.6257 14.2865L21.7005 18.2865C22.0947 18.6734 22.1005 19.3065 21.7136 19.7007C21.3267 20.0948 20.6936 20.1006 20.2995 19.7138L16.9336 16.4097L14.6502 18.7053C14.4625 18.894 14.2074 19.0001 13.9412 19.0001C13.6751 19.0001 13.4199 18.894 13.2322 18.7053L7.97329 13.418L3.70901 17.7053C3.31954 18.0969 2.68637 18.0986 2.2948 17.7091C1.90322 17.3197 1.90152 16.6865 2.29099 16.2949L7.26428 11.2948C7.45197 11.1061 7.70714 11 7.97329 11Z"
      />
      <path
        fill={fill}
        d="M17 2C17.5522 2.00011 18 2.44779 18 3V6H21C21.5523 6 22 6.44772 22 7C22 7.55228 21.5523 8 21 8H18V11C18 11.5522 17.5522 11.9999 17 12C16.4477 12 16 11.5523 16 11V8H13C12.4477 8 12 7.55228 12 7C12 6.44772 12.4477 6 13 6H16V3C16 2.44772 16.4477 2 17 2Z"
      />
    </svg>
  )
}

export default AddPhotoIcon
